<template>
  <div>
    <HeadNav :title="headNavImg.title" :titleEn="headNavImg.profiles" :src="headNavImg.picture"></HeadNav>
    <div class="content">
      <el-row>
        <el-col
          :span="6"
          style="border-left:1px solid rgb(220,220,220);border-right:1px solid rgb(220,220,220);border-top:1px solid rgb(220,220,220);"
        >
          <ContentNav :List="list" @increase="init" title="设备销售" titleEn="Equipment Sales"></ContentNav>
        </el-col>
        <el-col :span="18" style="padding: 0 50px">
          <h3>{{headTitle}}</h3>
          <el-divider></el-divider>
          <div v-html="contentHtmlPC"></div>
        </el-col>
      </el-row>
    </div>
    <!-- <div class="contentMobile">
          <ContentNav :List="moblieList" @increase="init" title="设备销售" titleEn="Equipment Sales"></ContentNav>
          <h3 style="color:#235E9D;margin-top:20px;">{{headTitle}}</h3>
          <el-divider></el-divider>
          <div v-html="contentHtmlMobile" class='mobileEditor' style='margin:20px 0'></div>
    </div> -->
    <el-row class="MobileRow">
      <el-col
        :span="24"
        style="border-left:1px solid rgb(220,220,220);border-right:1px solid rgb(220,220,220);border-top:1px solid rgb(220,220,220);"
      >
        <ContentNav :List="mobileList" title="设备销售" titleEn="Laboratory Services" @increase='init'></ContentNav>
      </el-col>
      <el-col :span='24' style='margin:20px 0'>
          <div v-html='contentHtmlMobile' class="mobileEditor"></div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import HeadNav from "../components/head.vue";
import ContentNav from "../components/content.vue";
import { getNavTitle, getProduct,getTheme } from "../api/allApiRequest.js";
export default {
  name: "sale",
  data() {
    return {
      list: [],
      headTitle: "",
      contentHtmlPC: "",
      contentHtmlMobile: "",
      headNavImg: {},
      value:0,
      activeId : '',
      userId:"",
       mobileList:[]
    };
  },
  components: {
    HeadNav,
    ContentNav
  },
  mounted() {
      this.value = location.hash.split('?')[1] ? location.hash.split('?')[1].split('&')[0].split('=')[1] : 0
    this.activeId =  location.hash.split('?')[1] ? location.hash.split('?')[1].split('&')[1].split('=')[1] : 0
    this.getThemeHead();
    getNavTitle().then(res => {
      res.data.forEach(item => {
        item.title == "设备销售" ? (this.list = item.children) : "";
      });
      for(let i in this.list){
        if(this.list[i].id == this.mobileId){
          this.mobileList.push(this.list[i])
        }
      }
      //默认拿到第一条数据显示处理
      if(this.cId){
        this.defaultShowId = this.cId;
          // console.log(this.defaultShowId,"cId" +this.cId)
          getProduct({defaultTypeId:this.defaultShowId}).then(res=>{
            let data = res.data.records[0]
            if(data){
                  this.headTitle = data.defaultTypeName;
                  this.contentHtmlPC = data.profiles
                  this.contentHtmlMobile = data.detailsPhone
            }
            this.loading = false
          })
      }else if(this.activeId){
        let childId = ""
        for(let i in this.list){
          if(this.list[i].id == this.activeId){
            childId = this.list[i].children[0].id
          }
        }
        this.defaultShowId = childId;
          getProduct({defaultTypeId:this.defaultShowId}).then(res=>{
            let data = res.data.records[0]
            if(data){
                  this.headTitle = data.defaultTypeName;
                  this.contentHtmlPC = data.profiles
                  this.contentHtmlMobile = data.detailsPhone
            }
            this.loading = false
          })
      }else{
        if(this.list.length){
          this.defaultShowId = this.list[0].children[0].id;
          this.headTitle = this.list[0].children[0].title;
          getProduct({defaultTypeId:this.defaultShowId}).then(res=>{
            let data = res.data.records[0]
            if(data){
                  this.contentHtmlPC = data.profiles
                  this.contentHtmlMobile = data.detailsPhone
            }
            this.loading = false
          })
        }else{
          this.headTitle="暂无数据";
          this.contentHtmlPC = "暂无数据";
          this.contentHtmlMobile = "暂无数据";
        }
      }
    });
  },
  methods: {
    init(e) {
      this.headTitle = e.title;
      this.contentPc = "暂无信息";
      this.contentMobile = "暂无信息";
      getProduct({ defaultTypeId: e.id }).then(res => {
        //  console.log(e.id)
        let data = res.data.records[0];
        if (data) {
          this.contentHtmlPC = data.profiles;
          this.contentHtmlMobile = data.detailsPhone;
        }
      });
    },
    //主题返现
    getThemeHead() {
      getTheme({
        themeType: this.value
      }).then(res => {
        this.headNavImg = res.data.records[0];
        res.data.records[0].picture =
          process.env.VUE_APP_WEB_URL + res.data.records[0].picture;
      });
    },
    mobileShowData(data){
      if(data.length){
          this.defaultShowId = data[0].children[0].id;
          this.headTitle = data[0].children[0].title;
          getProduct({defaultTypeId:this.defaultShowId}).then(res=>{
            let data = res.data.records[0]
            if(data){
                  this.contentHtmlPC = data.profiles
                  this.contentHtmlMobile = data.detailsPhone
            }
            this.loading = false
          })
        }else{
          this.headTitle="暂无数据";
          this.contentHtmlPC = "暂无数据";
          this.contentHtmlMobile = "暂无数据";
        }
    }
  },
  computed: {
      // 获取路由传的ID
      cId(){
          return this.$route.query.cId ? this.$route.query.cId : ""
      },
       mobileId(){
        return this.$route.query.id ? this.$route.query.id : ""
      }
  },
  watch:{
    $route(){
      this.userId= this.$route.query.id
    },
    userId() {
      if(this.$IsPc()){
        this.mobileList = []
        for(let i in this.list){
          if(this.list[i].id == this.mobileId){
            this.mobileList.push(this.list[i])
          }
        }
        this.contentHtmlMobile = "暂无数据"
        this.mobileShowData(this.mobileList)
      }else{
        this.$router.go(0)
      }
    }
  }
};
</script>
<style scoped>
.content {
  margin: 50px auto;
  width: 1190px;
}
.contentMobile,.MobileRow {
  display: none;
}
@media screen and (max-width: 750px) {
  .content {
    display: none;
  }
  .contentMobile {
    display: block;
    margin: 0 10px;
  }
  .MobileRow {
    margin: 20px 10px;
    display: block;
  }
}
</style>